function EktarOfferCatalog({ className, ...props }) {
    return <div id="ek_offer_catalog" className={className}>
        </div>
}

export default EktarOfferCatalog;